<template>
  <div>
    <nav
      class="navbar navbar-default"
      style="height: 65px; margin-bottom: 0px;"
    >
      <!-- <div style="margin-left: 40px;" class="">
                
                <div class="navbar-header"></div>
                <div class="collapse navbar-collapse" id="navbar-menu">
                    
               </div>
            </div> -->
      <Burger></Burger>
    </nav>
    <Sidebar>
      <ul class="sidebar-nav">
        <li
          v-if="$store.state.authentication.loggedIn"
          class="sidebar-nav-item"
        >
          <router-link :to="{ name: 'buildings' }">Login</router-link>
        </li>
        <li v-else class="dropdown sidebar-nav-item">
          <a
            href="#"
            class="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-expanded="false"
          >
            {{ user.firstName }} {{ user.lastName }}
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" role="menu">
            <li><a href="#" @click.prevent="logout">Logout</a></li>
          </ul>
        </li>
        <li class="dropdown sidebar-nav-item">
          <a
            href="#"
            class="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-expanded="false"
          >
            English
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" role="menu">
            <li><a href="/">Ελληνικά</a></li>
          </ul>
        </li>
         <li v-if="isAdmin" class="sidebar-nav-item">
          <router-link :to="{ name: 'account' }">Account</router-link>
        </li>
        <li v-if="isAdmin" class="sidebar-nav-item">
          <router-link :to="{ name: 'users' }">Users</router-link>
        </li>
        <li class="sidebar-nav-item"><a href="/#features">Features</a></li>
        <li class="sidebar-nav-item"><a href="/#pricelist">Pricelist</a></li>
        <li class="sidebar-nav-item"><a href="/">Support</a></li>
      </ul>
    </Sidebar>
  </div>
</template>
<script>
import { EventBus } from "@/events";
import Burger from "./Burger.vue";
import Sidebar from "./Sidebar.vue";
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import { router } from "@/_helpers";

export default {
  name: "app",
  data: function () {
    return {
      // drawer:this.drawer,
      drawerValue: this.drawerValue,
    };
  },

  mounted() {},
  watch: {
    screenChange: function () {
      if (this.windowWidth > 961) {
        this.drawer = true;
        EventBus.$emit("menuDrawerClicked", drawer);
      }
    },
  },
  methods: {
    logout: function () {
      EventBus.$emit("menuDrawerClicked", true);
      authenticationService.logout();
      router.push("/login");
    },
  },
  computed: {
    user() {
      return authenticationService.currentUserValue;
      /* alert( this.$store.state.authentication.user)
                 return this.$store.state.authentication.user;*/
    },
    isAdmin() {
      return this.currentUser && this.currentUser.role === Role.Admin;
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  components: {
    Burger,
    Sidebar,
  },
};
</script>
<style>
@media (max-width: 960px) {
  .hideOnMd {
    display: none !important;
  }
}
@media (min-width: 961px) {
  .showOnMd {
    display: none !important;
  }
}

.main-nav {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0.8rem;
}

ul.sidebar-panel-nav {
  list-style-type: none;
}

ul.sidebar-panel-nav > li > a {
  color: #fff;
  text-decoration: none;
  font-size: 1.5rem;
  display: block;
  padding-bottom: 0.5em;
}
</style>
